/*
Defines the custom element <ravel-assembly>
*/

import { RavelAssembly } from './src/RavelAssembly.js';

customElements.define('ravel-assembly', RavelAssembly);
